/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type UserBanPopoverContainer_local = {
    readonly accessToken: string | null;
    readonly dsaFeaturesEnabled: boolean | null;
    readonly " $refType": "UserBanPopoverContainer_local";
};
export type UserBanPopoverContainer_local$data = UserBanPopoverContainer_local;
export type UserBanPopoverContainer_local$key = {
    readonly " $data"?: UserBanPopoverContainer_local$data;
    readonly " $fragmentRefs": FragmentRefs<"UserBanPopoverContainer_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UserBanPopoverContainer_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "accessToken",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dsaFeaturesEnabled",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'd20da100a11e8a15a50dd445f1e429dc';
export default node;
